/**
 * Growth cycle + reminder configuration (tenant-wide, admin-edited).
 * Email/Teams reminder channels are surfaced as toggles but are not wired —
 * the mock only drives the in-app banner.
 */
import { emitGrowthChange } from './events';

const STORAGE_KEY = 'peoplevue_growth_config';

export const DEFAULT_GROWTH_CONFIG = {
  cycle: {
    // cycleId doubles as the label ("2026 review cycle").
    year: '2026',
    assessmentDue: '2026-09-30',
    // Months (1-12) when quarterly check-ins are expected.
    checkInMonths: [1, 4, 7, 10],
  },
  reminders: {
    inAppEnabled: true,
    daysBefore: 14,
    emailEnabled: false, // not connected — mock toggle only
    teamsEnabled: false, // not connected — mock toggle only
  },
};

export function getGrowthConfig() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (!stored) return structuredClone(DEFAULT_GROWTH_CONFIG);
    return {
      cycle: { ...DEFAULT_GROWTH_CONFIG.cycle, ...stored.cycle },
      reminders: { ...DEFAULT_GROWTH_CONFIG.reminders, ...stored.reminders },
    };
  } catch {
    return structuredClone(DEFAULT_GROWTH_CONFIG);
  }
}

export function saveGrowthConfig(config) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(config)); } catch { /* ignore */ }
  emitGrowthChange();
  return config;
}

export function getCycleId() {
  return getGrowthConfig().cycle.year;
}
